var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: { "dialog-class": "go-modal-access" },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c("div", { staticClass: "go-block-between" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.close.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.buttons.close")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.ok.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.okText))]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "go-block-header" }, [
        _c("div", { staticClass: "go-msg-icon" }, [
          _c("p", {
            staticClass: "go-text",
            domProps: { innerHTML: _vm._s(_vm.title) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-block-body" }, [
        _c("span", {
          staticClass: "go-text-sub",
          domProps: { innerHTML: _vm._s(_vm.description) },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "go-channel-msg" }, [
          _c("em", [
            _c("i", { staticClass: "go-icon-20 go-icon-alert-circle-filled" }),
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.warningMessage) } }),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "go-channel-content" }, [
          _c("div", { staticClass: "go-elements" }, [
            _c(
              "div",
              { staticClass: "go-channel-link" },
              _vm._l(_vm.agentChannels, function (agent, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    staticClass: "btn go-btn-default",
                    attrs: { type: "button" },
                  },
                  [
                    _c("i", {
                      staticClass: "go-icon-16 go-icon-browser-share",
                    }),
                    _vm._v(" "),
                    _c("em", { staticClass: "go-text" }, [
                      _vm._v(" " + _vm._s(agent.bpName) + " "),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }